import React from "react"
import { useIntl } from "react-intl"

import { asterisksToSpan } from "../../utils/text"
import { Client } from "../vignettes/Client"
import { Post } from "../vignettes/Post"

export function RelatedItems({ relatedItems, type, locale }) {
  const intl = useIntl()
  return (
    <div className="pt-12 bg-charlestonGreen-100">
      <div className="max-w-7xl px-4 pt-8 pb-8 mx-auto sm:pt-16 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2
            className="mt-1 text-2xl font-extrabold  sm:text-3xl sm:tracking-tight lg:text-4xl"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: asterisksToSpan(
                intl.formatMessage({ id: "postRelatedPosts" }),
                "text-blue-600"
              ),
            }}
          />
        </div>
      </div>
      <div className="relative">
        <div className="max-w-7xl px-4 pb-16 mx-auto sm:px-8 sm:pb-24">
          <div className="relative grid max-w-lg gap-5 mx-auto mt-12 lg:grid-cols-3 lg:max-w-none">
            {relatedItems.map((item, key) =>
              type === "client" ? (
                // eslint-disable-next-line react/no-array-index-key
                <Client client={item} key={key} />
              ) : (
                // eslint-disable-next-line react/no-array-index-key
                <Post post={item} locale={locale} key={key} />
              )
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
